import { useUserContext } from 'engage/context/UserContext';
import React from 'react';
import styles from './PageHeader.module.scss';
import cx from 'classnames';

const PageHeader = ({
    title,
    info = null, // null || component || boolean(false) -> default(user) data || component || no info 
    className }) => {
    const { user, appConfig } = useUserContext();

    return <div className={cx(styles.wrapper, className)}>
        {title && <h1 className={styles.title}>{title}</h1>}
        <p className={styles.userInfo}>
            {info != null ? info : `${user?.userFullName}${(appConfig?.name ? ' / ' + appConfig.name : '')}`}
        </p>
    </div>
}

export default PageHeader;